import axios from "axios";

export class GetWhiteBrandLogo {
  constructor(
    private readonly frontend
  ) {}

  async run(white_brand) {
    let args = {
      white_brand:white_brand,   
    }
    let response = await axios.get(process.env.VUE_APP_API_ENDPOINT+'/get_white_brand_logo/', {params:args})
    if ( response.data.url && response.data.url != '' ){
      this.frontend.hasWhiteBrand = true
      this.frontend.whiteBrandLogoURL = response.data.url
    } else {
      this.frontend.hasWhiteBrand = false
      this.frontend.$router.push('/login')
    }
  }
}